import React from 'react';
import { Form, Input, Button, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import AuthService from '../../services/AuthService';
import { clearStoredAdminCompanyCode, isReportAdmin } from '../../helpers/reportBranches';

const Login = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();

    const onFinish = async (values) => {
        try {
            const companyCode = values.company && typeof values.company === 'string'
                ? values.company.trim()
                : (values.company || null);

            const response = await AuthService.login({
                UserName: values.username,
                Secret: values.password,
                CompanyCode: companyCode
            });
            if (response.status === 200) {
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('x-access-token', response.data.token);
                localStorage.setItem('userDetails', JSON.stringify(response.data.user));
                if (isReportAdmin(response.data.user) && !companyCode) {
                    clearStoredAdminCompanyCode();
                }
                message.success('Giriş başarılı!');
                navigate('/dashboard');
            } else {
                const backendMessage = response.error?.message || response.error;
                if (response.status === 0 || response.status >= 500) {
                    message.error(backendMessage || 'Sunucuya bağlanılamadı. BMS backend (5100) çalışıyor mu kontrol edin.');
                } else if (String(backendMessage || '').toLowerCase().includes('company code')) {
                    message.error('Şirket kodu gerekli. Admin değilseniz şirket kodunuzu girin.');
                } else {
                    message.error(backendMessage || 'Kullanıcı adı veya şifre yanlış.');
                }
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || error.message || 'Sunucuya bağlanılamadı. Lütfen internet bağlantınızı kontrol edin.';
            message.error(errorMessage);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <div className="flex flex-col items-center justify-center mb-8">
                    <div className="flex flex-col items-center justify-center gap-2 mb-6">
                        <img src={`${process.env.PUBLIC_URL || ''}/ordermax-bulut-logo.png`} alt="OrderMAX Bulut" className="h-12 object-contain" />
                    </div>
                    <p className="text-gray-600 font-medium">Lütfen hesabınıza giriş yapın</p>
                </div>

                <Form
                    form={form}
                    name="login"
                    onFinish={onFinish}
                    layout="vertical"
                    size="large"
                >
                    <Form.Item
                        name="company"
                        rules={[]}
                    >
                        <Input
                            placeholder="Şirket Kodu (admin için isteğe bağlı)"
                            className="rounded-lg font-medium"
                        />
                    </Form.Item>

                    <Form.Item
                        name="username"
                        rules={[{ required: true, message: 'Lütfen kullanıcı adınızı girin!' }]}
                    >
                        <Input
                            prefix={<UserOutlined className="text-gray-400" />}
                            placeholder="Kullanıcı Adı"
                            className="rounded-lg font-medium"
                        />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: 'Lütfen şifrenizi girin!' }]}
                    >
                        <Input.Password
                            prefix={<LockOutlined className="text-gray-400" />}
                            placeholder="Şifre"
                            className="rounded-lg font-medium"
                        />
                    </Form.Item>

                    <Form.Item>
                        <Button
                            type="primary"
                            htmlType="submit"
                            size="large"
                            className="w-full !bg-brand hover:!bg-brand-light active:!bg-brand-dark rounded-lg h-12 text-lg font-semibold tracking-wide"
                        >
                            Giriş Yap
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};

export default Login;